module.exports = __webpack_public_path__ + "img/app_purpose.743b8c25.jpg";